exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-main[data-v-292a471f]{height:99%;display:flex;flex-direction:column;border-top:1px solid #dedede}.div-top[data-v-292a471f]{display:flex;align-items:center;height:2.875rem;padding:.375rem .625rem}.div-top[data-v-292a471f] .van-dropdown-menu__bar{box-shadow:none}.div-top .org-name[data-v-292a471f]{flex:2;font-size:14px;font-weight:bolder;color:#464646;margin-left:.375rem}.div-top .filter[data-v-292a471f]{text-align:right;flex:1}.div-top .filter span[data-v-292a471f]{font-size:.875rem}.div-top .filter img[data-v-292a471f]{width:1.25rem;vertical-align:middle}.cont-list[data-v-292a471f]{overflow:auto;flex:1;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-292a471f","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/contractor/ContractorHistory.vue
// module id = 868
// module chunks = 0